import script from "./RewardsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./RewardsTable.vue?vue&type=script&setup=true&lang=js"

import "./RewardsTable.vue?vue&type=style&index=0&id=1f697f90&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f697f90"]])

export default __exports__